export default {
  computed: {
    isAdmin() {
      const adminRoles = ['systemadmin', 'companyadmin']
      return adminRoles.includes(this.$store.state.auth?.user?.role)
    },
    isCompanyAdmin() {
      return this.$store.state.auth?.user?.role === 'companyadmin'
    },
    isSystemAdmin() {
      return this.$store.state.auth?.user?.role === 'systemadmin'
    }
  }
}
